import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { string } from 'yup';
import FormikControls from '../form-components/FormikControls';
import { userLoginAction } from '../../services/actions/loginActions';
import { loginReset } from '../../redux/features/loginSlice';
import { forgotPasswordReset } from '../../redux/features/forgotPasswordSlice';
import { apiAuthenticate } from '../../redux/features/appSlice';
const LoginForm = () => {
    let apiToken = useSelector((state) => state.app.apiToken);
    const { isLoading, loginError } = useSelector((state) => state.login);
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    let from = location.state?.from?.pathname || "/";

    useEffect(() => {
        if (loginError !== '') {
            dispatch(loginReset());
            dispatch(forgotPasswordReset());
        }
        if (apiToken === '') {
            getApiToken();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getApiToken = async () => {
        const response = await dispatch(apiAuthenticate());
        return response;
    }
    const initialValues = {
        loginFor: 'M',
        code: '',
        username: '',
        password: ''
    };
    const validationSchema = Yup.object({
        loginFor: Yup.string()
            .required('required'),
        code: Yup.string()
            .required('Required'),
        username: string()
            .required('Required'),
        password: string()
            .required('Required')
    });
    const onSubmit = async (values) => {
        if (apiToken === '') {
            let resp = await getApiToken();
            if (resp?.payload?.data?.token !== '') {
                apiToken = resp?.payload?.data?.token;
            }
        }
        const loginValidation = async (loginDetails, apiToken) => {
            const response = await dispatch(userLoginAction(loginDetails, apiToken));
            if (loginDetails.loginFor === 'M' && response.status === 'Ok') {
                navigate(from, { replace: true });
            } else if ((loginDetails.loginFor === 'B' || 'C') && response.status === 'Ok' && response.userToken !== "") {
                window.location.replace(response.data.redirectUrl);
                return false;
            }

        }
        loginValidation(values, apiToken)
    }
    const focusElement = (elementID) => {
        elementID &&
            document.getElementById(elementID) &&
            document.getElementById(elementID).focus();
    };
    const handlekeyDown = (e, nextId, prevId) => {
        if (e.key === "Enter") {
            e.preventDefault();
            focusElement(nextId);
        } else if (e.key === "Escape") {
            focusElement(prevId);
        }
    };

    return (
        <div className="login--content">
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
            >
                {({ values, setFieldValue, submitForm }) => {
                    return (
                        <Form>
                            {isLoading && <div className='form-error'>Authenticating... </div>}
                            {loginError !== '' && !isLoading && <div className='form-error'>{loginError}</div>}
                            <div className="input--wrapper">
                                <FormikControls
                                    id="code"
                                    control="input"
                                    type="text"
                                    name="code"
                                    label="Enter Code"
                                    autoFocus={true}
                                    autoComplete="off"
                                    style={{ textTransform: "uppercase" }}
                                    onKeyDown={(e) => handlekeyDown(e, "username", "login")}
                                />
                            </div>
                            <div className="input--wrapper">
                                <FormikControls
                                    id="username"
                                    control="input"
                                    type="text"
                                    name="username"
                                    label="Enter Login ID"
                                    autoComplete="off"
                                    onKeyDown={(e) => handlekeyDown(e, "password", "code")}
                                />
                            </div>
                            <div className="input--wrapper">
                                <FormikControls
                                    id="password"
                                    control="input"
                                    type="password"
                                    name="password"
                                    label="Enter Password"
                                    autoComplete="off"
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                            submitForm()
                                        } else {
                                            handlekeyDown(e, "login", "username")
                                        }
                                    }}
                                />
                            </div>
                            <button
                                id="login"
                                className="submit--btn"
                                onClick={(e) => { submitForm() }}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        submitForm();
                                    } else {
                                        handlekeyDown(e, "code", "password");
                                    }
                                }}
                            >
                                LOGIN
                            </button>
                        </Form>
                    )
                }}
            </Formik>
        </div>
    )
}

export default LoginForm
